import { render, staticRenderFns } from "./productSpu.vue?vue&type=template&id=57594628&"
import script from "./productSpu.vue?vue&type=script&lang=js&"
export * from "./productSpu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports